import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export default function useGetAssetClasses(type, series, name) {
  return useAxios({
    url: '/api/v1/funds/asset_classes',
    method: 'GET',
    params: { type, series, name },
  }, { manual: true });
}
